export default __webpack_public_path__ + "static/media/chill-1x.fd15426c.png";